import React, {Component} from 'react';
import styles from 'css/screens/result.css';

/**
 * Analysis：現状分析
 */
export default class Analysis extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <div className={styles.advice}>
        <h2>御社が強化すべきは<span>現状分析</span>です。</h2>
        <p>
          自社の動向だけをみていませんか？<br />
          競合も含めた自社のポジショニングや<em />強み/弱み分析を行い、<br />
          勝てるPR戦略を立案しましょう。<br />
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/result/advice/analysis.js